import React from 'react';
import { Link } from 'react-router-dom'
import { dateFormat, formatPhoneNumber, getCustomLabel, getModeOfNotification, getShortName } from '../../../itrust_common/components/HelperFunctions'
import { connect } from 'react-redux';
import DateFormatView from '../../../itrust_common/components/others/DateFormatView';

let PatientInfo = props => {
  const { patient, handeSearchResultClose, visionInsuranceTemplate, medicalInsuranceTemplate, RenderPatientAction } = props

  return (
    <div className="selected-patient mb-5">
      <div className="patient-profile bg-light">
        <div className="d-flex flex-row align-items-center justify-content-between border-bottom border-white py-5 px-3">
          <div>
            <span className='d-flex flex-row align-items-center'>
              {getShortName(patient, 'mr-5 width-2-half height-2-half', 'mr-5 width-2-half height-2-half font-size-16 ')}
              {patient.first_name} {patient.last_name}
            </span>
            {patient?.nickname && (
              <h6 style={{marginLeft:'40px'}}>{`"${patient.nickname}"`}</h6>
            )}
          </div>
          {RenderPatientAction ?
            <RenderPatientAction /> :
            <>
              {handeSearchResultClose ?
                <button type="button" className="close" onClick={() => handeSearchResultClose()}>&times;</button>
                :
                <>{patient.id && <Link to={`/patients/${patient.id}/overview`} target='_blank' className="text-primary">View Profile</Link>}</>
              }
            </>
          }
        </div>
        <div className="row px-3 patient-profile-info">
          <div className="col-5 py-2"><span>Date Of Birth</span></div>
          <div className="col-7 py-2 text-muted">
            <span>
              <DateFormatView date={patient.date_of_birth} notExist="N/A" />
            </span>
          </div>
          <div className="col-5 py-2"><span>Phone</span></div>
          <div className="col-7 py-2 text-muted"><span>{formatPhoneNumber(patient.cell_phone || "N/A")}</span></div>
          <div className="col-5 py-2"><span>Email</span></div>
          <div className="col-7 py-2 text-muted"><span>{patient.email || "N/A"}</span></div>
          <div className="col-5 py-2"><span>Mode Of Notification</span></div>
          <div className="col-7 py-2 text-muted"><span>{getModeOfNotification(patient.mode_of_notification_type) || "N/A"}</span></div>
          <div className="col-5 py-2">
            <span>{visionInsuranceTemplate && getCustomLabel(visionInsuranceTemplate, 'insurance')}</span>
          </div>
          <div className="col-7 py-2 text-muted">
            {patient.patient_vision_insurance_attributes && <>
              <span>{patient.patient_vision_insurance_attributes.insurance_name}</span>
              <span className="mx-2">|</span>
              <span>MID: {patient.patient_vision_insurance_attributes.member_id}</span>
            </>}
          </div>
          <div className="col-5 py-2">
            <span>{medicalInsuranceTemplate && getCustomLabel(medicalInsuranceTemplate, 'insurance')}</span>
          </div>
          <div className="col-7 py-2 text-muted">
            {patient.patient_medical_insurance_attributes && <>
              <span>{patient.patient_medical_insurance_attributes.insurance_name}</span>
              <span className="mx-2">|</span>
              <span>MID: {patient.patient_medical_insurance_attributes.member_id}</span>
            </>}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { setting: { patientTemplate: { patient_template } } } = state
  const patientInsuranceData = patient_template.personal_information?.insurance_detail?.fields
  return {
    visionInsuranceTemplate: patientInsuranceData?.vision_insurance?.fields,
    medicalInsuranceTemplate: patientInsuranceData?.medical_insurance?.fields
  }
}

export default connect(mapStateToProps)(PatientInfo);